import React from "react";

interface GameItem {
  href: string;
  imgSrc: string;
  alt?: string;
  onClick?: () => void;
}

const games: GameItem[] = [
  {
    href: "/cong-thuc",
    imgSrc: "/assets/cong-thuc.png",
  },
  {
    href: "/casino",
    imgSrc: "/assets/ai-baccarat.png",
  },
];

const CustomLobby: React.FC = () => {
  return (
    <div className="relative w-full max-w-4xl mx-auto px-4 ">
      {/* Header */}
      <div className="flex justify-center items-center mb-2 mt-8 ">
        <div className="max-w-xl">
          <img className="w-full" src="/assets/logo-login.png" alt="Lobby" />
        </div>
      </div>

      {/* Games Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {games.map((game, index) => (
          <div
            key={index}
            className={`cursor-pointer transition-transform hover:scale-105 ${
              index === 1 ? 'order-first sm:order-none' : ''
            }`}
            onClick={game.onClick}
          >
            {game.onClick ? (
              <div>
                <figure className="overflow-hidden rounded-xl shadow-md">
                  <img
                    src={game.imgSrc}
                    alt={game.alt || ""}
                    className="w-[80%] mx-auto h-auto object-cover"
                  />
                </figure>
              </div>
            ) : (
              <a href={game.href}>
                <figure className="overflow-hidden rounded-xl shadow-md">
                  <img
                    src={game.imgSrc}
                    alt={game.alt || ""}
                    className="w-[80%] mx-auto h-auto object-cover"
                  />
                </figure>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomLobby;
